import { Component, HostBinding, OnInit } from '@angular/core';

import { LanguageService } from '../../../../../core/services/language.service';
import { RoutingService } from '../../../../../core/services/routing.service';

@Component({
  selector: 'app-cgu',
  templateUrl: './cgu.component.html',
  styleUrls: ['./cgu.component.scss'],
})
export class CguComponent implements OnInit {
  @HostBinding('class.content-tab') tabClass = true;
  @HostBinding('style.order') tabOrder = 1;

  constructor(public languageService: LanguageService, private routingService: RoutingService) {
    this.routingService.itemChange$.next(this.routingService.getIndexOfTab('cgu'));
  }

  ngOnInit(): void {}
}
